import data from "./../data/storitev.json";
import GetImage from "../component/GetImage.js";

const Storitev = () => {
  return (
    <div className="storitev" id="storitev">
      <div className="row">
        <div className="column_left">
          <div className="header">{data[0].text}</div>
          <div className="text">
            {data.map((row, n) => (
              <div key={n}>{row.text}</div>
            ))}
          </div>
        </div>
        <div className="column_right">
          <div className="image">
            <img src={GetImage("aleksa_0.jpg")} alt="servis klime" title="klima servis" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Storitev;
